import React from 'react';
import Autosuggest from 'react-autosuggest';

import {
    SEARCH_DEBOUNCE_DELAY,
    SEARCH_MIN_CHARS,
    INVESTIGATION_ENTITY_TYPES,
    HTTP_OPTIONS
} from '@silverfort-nodelibs/common/utils/consts';
import { httpGet } from '../utils';

import searchIcon from './Images/search-small.png';
import nextIcon from './Images/next.png';
import userIcon from './Images/user-grey.png';
import serverIcon from './Images/server-grey.png';
import azureIcon from '../Investigation/Images/azure-grey.svg';
import oktaIcon from '../Investigation/Images/okta-grey.svg';
import connectivityErrorIcon from '../common/Images/connectivity_error.png';
import InvestigationDrawer from '../InvestigationDrawer/InvestigationDrawer';
import { useAppDrawer } from '../AppDrawer/AppDrawerProvider';

class SearchEntityNoContext extends React.Component {
    constructor() {
        super();
        this.state = {
            suggestions: [],
            query: '',
            IsLoading: false,
            LastRequestID: -1,
            IsConnectivityError: false
        };
        this.getSuggestions = debounce(this.getSuggestions.bind(this), SEARCH_DEBOUNCE_DELAY);
    }

    async getSuggestions(query) {
        let escapedQuery = query.trim();

        if (escapedQuery === '' || escapedQuery.length < SEARCH_MIN_CHARS) {
            return [];
        }

        escapedQuery = encodeURIComponent(escapedQuery);

        this.state.LastRequestID = this.state.LastRequestID + 1;

        const baseSearchURL = this.props.searchEntitiesTypes ? '/users/searchEntitiesByTypes' : '/users/searchEntities';
        const reqUrl = `${baseSearchURL}/${escapedQuery}/${this.state.LastRequestID}`;
        this.setState({ IsLoading: true });

        try {
            const response = await httpGet(reqUrl, {
                [HTTP_OPTIONS.REQ_OPTIONS]: {
                    params: { hideDeleted: this.props.hideDeleted, entitiesTypes: this.props.searchEntitiesTypes }
                }
            });

            const isLoading = parseInt(response.data.requestID) !== this.state.LastRequestID;
            if (isLoading) {
                return;
            }

            this.setState({ suggestions: response.data.Results, IsLoading: isLoading, IsConnectivityError: false });
        } catch (error) {
            this.setState({ IsConnectivityError: true });
            console.error(error);
        }
    }

    onSuggestionsFetchRequested(newQuery) {
        this.getSuggestions(newQuery.value);
    }

    getSuggestionValue(suggestion) {
        return suggestion.display_name || suggestion.name;
    }

    StoreInputReference(autosuggest) {
        if (autosuggest !== null) {
            this.input = autosuggest.input;
        }
    }

    renderSuggestion(suggestion) {
        let suggestionName = suggestion.name ? suggestion.name : suggestion.display_name;
        if (suggestion.is_deleted) {
            suggestionName += ' (deleted)';
        }

        const title = `${suggestion.path ? suggestion.path : suggestionName}${
            suggestion.domain_name ? ` (${suggestion.domain_name})` : ''
        }`;
        return (
            <span className="suggestion-content" title={title}>
                <div className="textArea">
                    {suggestion.investigation_type === INVESTIGATION_ENTITY_TYPES.USER.id && (
                        <img src={userIcon} alt="" />
                    )}
                    {suggestion.investigation_type === INVESTIGATION_ENTITY_TYPES.RESOURCE.id && (
                        <img src={serverIcon} alt="" />
                    )}
                    {suggestion.investigation_type === INVESTIGATION_ENTITY_TYPES.APPLICATION.id && (
                        <img className="application" src={azureIcon} alt="" />
                    )}
                    {suggestion.investigation_type === INVESTIGATION_ENTITY_TYPES.OKTA.id && (
                        <img className="okta" src={oktaIcon} alt="" />
                    )}
                    <div>
                        <div className="name">{suggestionName}</div>
                        <div className="domain-name">{suggestion.domain_name}</div>
                    </div>
                </div>
                <img className="next" src={nextIcon} alt="" />
            </span>
        );
    }

    onSuggestionsClearRequested() {
        const stateProps = { suggestions: [] };
        if (this.props.clearQuery !== false) {
            stateProps.query = '';
        }
        this.setState(stateProps);
    }

    onSuggestionSelected(event, { suggestion }) {
        if (this.props.onSuggestionSelected) {
            this.props.onSuggestionSelected(suggestion);
            return;
        }

        this.props.appDrawerContext.displayContent(
            <InvestigationDrawer guid={suggestion.guid} identifier={suggestion.name} adType={suggestion.type} />
        );
    }

    onChange(event, { newValue }) {
        if (newValue === '') {
            this.setState({ suggestions: [], query: '' });
        } else {
            this.setState({ query: newValue });
        }
    }

    render() {
        const inputProps = {
            placeholder: this.props.inputPlaceholder ? this.props.inputPlaceholder : 'Search for User or Resource...',
            value: this.state.query,
            onChange: this.onChange.bind(this)
        };

        return (
            <div className={`search-container search-entity`}>
                <div>
                    <img className="search-icon" src={searchIcon} alt="" />
                    {this.state.IsLoading && !this.state.IsConnectivityError && (
                        <i className="searchLoading fa fa-refresh fa-spin fa-3x fa-fw" aria-hidden="true"></i>
                    )}
                    {this.state.IsConnectivityError && (
                        <div className="connectivityError" title={'Connectivity failure'}>
                            <img src={connectivityErrorIcon} alt="" />
                        </div>
                    )}
                    <Autosuggest
                        suggestions={this.state.suggestions}
                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested.bind(this)}
                        getSuggestionValue={this.getSuggestionValue.bind(this)}
                        renderSuggestion={this.renderSuggestion.bind(this)}
                        onSuggestionsClearRequested={this.onSuggestionsClearRequested.bind(this)}
                        onSuggestionSelected={this.onSuggestionSelected.bind(this)}
                        inputProps={inputProps}
                        alwaysRenderSuggestions={false}
                        ref={this.StoreInputReference.bind(this)}
                    />
                </div>
            </div>
        );
    }
}

const SearchEntity = (props) => {
    const drawerContext = useAppDrawer();
    return <SearchEntityNoContext {...props} appDrawerContext={drawerContext} />;
};

export default SearchEntity;

function debounce(fn, delay) {
    let timer = null;
    return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    };
}
